export default __webpack_public_path__ + "static/media/purple top hat.cf0f176b.png";